import domtoimage from 'dom-to-image'
import { saveAs } from 'file-saver'
import React from 'react'
import {
  ComposedChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Area,
  CartesianGrid,
  ReferenceLine,
  ReferenceDot,
} from 'recharts'

const CustomXLabel = (props) => {
  const { x, y, payload } = props
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={20}
        fontSize={11}
        textAnchor="middle"
        fill="#666"
        transform="rotate(-13)"
      >
        {payload.value}
      </text>
    </g>
  )
}

const CustomYLabel = (props) => {
  const { x, y, payload, unit } = props
  return (
    <g>
      <text
        x={x}
        y={y}
        dy={5}
        dx={-15}
        fontSize={11}
        textAnchor="middle"
        fill="#666"
      >
        {payload.value}
        {unit}
      </text>
    </g>
  )
}

const CustomizedReferenceLineLabel = (props) => {
  const { date, viewBox } = props
  return (
    <g>
      <text
        x={viewBox.x}
        y={viewBox.y}
        dy={-5}
        // dx={-15}
        fontSize={11}
        textAnchor="middle"
        // fill="#666"
      >
        {date}
      </text>
    </g>
  )
}

const CustomTooltip = ({ payload }) => {
  if (!payload || payload.length === 0) return null
  return payload.map((entry, i) => {
    return (
      <div
        key={i}
        className="flex flex-col px-4 py-3 rounded bg-gray-50 opacity-90"
      >
        <div>
          <span className="mr-1 text-xs font-bold">Date:</span>
          <span className="text-xs">{entry.payload.formattedDate}</span>
        </div>
        <div className="mt-2">
          <span className="mr-1 text-xs font-bold">Percentage of Target:</span>
          <span className="text-xs">
            {entry.payload.percentageOfTarget === 'N/A'
              ? 'N/A'
              : Math.round(entry.payload.percentageOfTarget)}
          </span>
        </div>
      </div>
    )
  })
}

export default function GrowthGraph({ modelData, data, currentHourObject }) {
  const { resultsGraph } = modelData.elements
  
  for (let i = 0; i < data.length; i++) {
    if (data[i].percentageOfTarget > 250 ) {
      data[i].percentageOfTarget = 250
    }
  }

  let currenHourGraphObject = null
  if (currentHourObject)
    currenHourGraphObject = data.find((d) => d.ms === currentHourObject.ms)

  function downloadPNG() {
    domtoimage
      .toBlob(document.getElementById(`${resultsGraph.title}-growth-graph`))
      .then((blob) => saveAs(blob, `${modelData.title} Chart.png`))
  }
  if (data === null) return null
  return (
    <div className="w-full" aria-hidden="true">
      <div className="flex items-center justify-between mb-6">
        <h2 className="inline-block text-lg font-semibold text-gray-600 sm:text-xl md:text-2xl">
          {resultsGraph.title}
        </h2>

        <div className="flex items-center justify-center rounded-md">
          <button
            type="button"
            aria-label="download graph in png format"
            onClick={downloadPNG}
            className="inline-flex items-center p-2 text-sm font-bold leading-4 text-white transition duration-150 ease-in-out border border-transparent rounded-md sm:px-3 sm:py-2 bg-secondary-800 hover:bg-secondary-700 focus:outline-none focus:border-secondary-900 focus:shadow-outline-secondary active:bg-secondary-900"
          >
            <svg
              className="-ml-0.5 mr-2 h-4 w-4 text-white"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
            </svg>
            <span className="hidden mr-1 sm:inline-block">Download </span>{' '}
            <span className="text-white">PNG</span>
          </button>
        </div>
      </div>

      <ResponsiveContainer
        width="100%"
        height={450}
        id={`${resultsGraph.title}-growth-graph`}
      >
        <ComposedChart
          data={data}
          margin={{ top: 20, right: 35, left: 20, bottom: 20 }}
          className="bg-white border-b border-gray-200 shadow sm:rounded-lg"
        >
          <XAxis
            dataKey="formattedDate"
            interval={'preserveStartEnd'}
            axisLine={true}
            tick={<CustomXLabel />}
          ></XAxis>
          <YAxis
            id="yAxis"
            dataKey="percentageOfTarget"
            tick={<CustomYLabel unit={'%'} />}
          />
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <Tooltip content={<CustomTooltip />} />
          <Legend verticalAlign="top" name="Percentage Of Target" height={60} />
          <Area
            type="monotone"
            dataKey="percentageOfTarget"
            stroke="#1D99E1"
            fill="#86BFDF"
            dot={false}
            name={`Percentage Of Target`}
          />

          {currenHourGraphObject && (
            <ReferenceLine
              x={currenHourGraphObject.formattedDate}
              stroke="#4a5568"
              strokeWidth={1.1}
              label={
                <CustomizedReferenceLineLabel
                  date={currenHourGraphObject.formattedDate}
                />
              }
            />
          )}
          {currenHourGraphObject && (
            <ReferenceDot
              x={currenHourGraphObject.formattedDate}
              y={currenHourGraphObject.percentageOfTarget}
              r={4}
              fill="#4a5568"
              stroke="none"
            />
          )}
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}
